import initialState from './initialState.js';
import constants from '../helpers/constants.js';

export default function formConfigReducer(state = initialState.formConfig, action) {
    switch (action.type) {
        case constants.FORM_CONFIG_HIDE_DOWNLOAD:
            return Object.assign({}, state, { downloadHide: action.data });
        case constants.FEATURE_CONFIGURATION:
            return Object.assign({}, state, { featureConfiguration: action.config });
        default:
            return state;
    }
}
